import AppStore from '~/vendor/cxy/icons/glyphs/legacy/AppStore';
import Betslip from '~/vendor/cxy/icons/glyphs/legacy/Betslip';
import FairPlayLogo from '~/vendor/cxy/icons/glyphs/legacy/FairPlayLogo';
import GooglePlay from '~/vendor/cxy/icons/glyphs/legacy/GooglePlay';
import Info from '~/vendor/cxy/icons/glyphs/legacy/Info';

// Stands in for @cx-web/icons, which looks any name up in cxy's whole glyph registry: product-plus
// passes only these names and never enables the UK set.
const icons = { AppStore, Betslip, FairPlayLogo, GooglePlay, Info };

interface IconProps {
  className?: string;
  height?: number | string;
  icon: keyof typeof icons;
  width?: number | string;
}

const Icon = ({ icon, ...iconProps }: IconProps) => {
  const Component = icons[icon];

  return <Component {...iconProps} />;
};

export default Icon;
